import client from './apiClient';

function createTicket(support) {
  return client('support', { body: support });
}

export { createTicket };
